<div class="gt-page-header">
  <h1><i class="fa fa-wrench"></i> No Modules Assigned</h1>
</div>
<div class="gt-page-body-dark">
  <div class="holder-404">
    <i style="font-size:88px; margin-top: 50px" class="fa fa-user-times"></i>
    <h3>Sorry. Currently you do not have any modules assigned to your account.</h3>
  </div>
</div>
